import { createIcon } from '../icon'
import UserIcon from '../svg/UserIcon'

export const UserIconDefault = createIcon(UserIcon)
